import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuillModule } from 'ngx-quill';
import { Api } from '../../services/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mdl-send-mail',
  imports: [FormsModule, CommonModule, QuillModule, NgSelectModule],
  templateUrl: './mdl-send-mail.html',
  styleUrl: './mdl-send-mail.css'
})
export class MdlSendMail implements OnInit {
  private api = inject(Api);
  public outlook_mail: string = '';
  public outlook_connected: boolean = false;

  contenido = '';

  public request: any = {
    to: '',
    subject: '',
    body: ''
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlSendMail>,
    private router: Router
  ) { 
    if (this.data && this.data.mailData) {
      this.request = { ...this.request, ...this.data.mailData };
    }
  }

  ngOnInit(): void {
    console.log('Modal de envío de correo iniciado con datos:', this.data);
    this.getOutlookAccount();
  }

  getOutlookAccount(){
    this.api.getOutlookInfo().subscribe({
      next: (data: any) => {
        this.outlook_mail = data.outlook_account_email;
        this.outlook_connected = data.outlook_connected;
      },
      error: (error) => {
        console.error('Error fetching Outlook account:', error);
      },
    });
  }

  sendMail(): void {
    if (!this.request.to || !this.request.subject || !this.request.body) {
      console.error('Faltan campos obligatorios');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.request.to)) {
      console.error('El formato del email no es válido');
      return;
    }

    this.api.showLoading();
    console.log('Datos del correo a enviar:', this.request);
    
    const mailData = {
      to: this.request.to,
      subject: this.request.subject,
      body: this.request.body
    };

    this.api.sendOutlookMail(mailData).subscribe({
      next: (resp: any) => {
        console.log('Correo enviado con éxito:', resp);
        this.api.hideLoading();
        this.mdl.close(true);
      },
      error: (err: any) => {
        this.api.hideLoading();
        console.error('Error al enviar el correo:', err);
      }
    });
  }

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image']
    ]
  };

  onContentChanged(event: any) {

  }

  onEditorCreated(event: any) {
    console.log('Editor de correo creado:', event);
  }

  obtenerTextoPlano() {
    const temp = document.createElement('div');
    temp.innerHTML = this.request.body;
    return temp.textContent || temp.innerText || '';
  }

  validarLongitudMensaje(): boolean {
    const textoPlano = this.obtenerTextoPlano();
    return textoPlano.length >= 10;
  }

  closeMdl(): void {
    this.mdl.close();
  }

  leerData() {
    const textoPlano = this.obtenerTextoPlano();
    console.log('=== DEBUG CORREO ===');
    console.log('Datos completos:', this.request);
    console.log('To:', this.request.to);
    console.log('Subject:', this.request.subject);
    console.log('Body HTML:', this.request.body);
    console.log('Body texto plano:', textoPlano);
    console.log('Longitud válida:', this.validarLongitudMensaje());
    console.log('===================');
  }

  connectOutlook() {
    const tenantId = "7eafb56d-40c8-4934-842a-c9207647bbe0";
    const clientId = "6b59dcd9-2f94-41f7-adbd-6a4050cf015c";
    const redirectUri = "http://localhost:3000/api/auth/callback"; // backend
    const scopes = [
      "openid",
      "profile",
      "offline_access",
      "User.Read",
      "Mail.Send",
      "Calendars.Read"
    ];

    const jwtLocal = localStorage.getItem("crmtoken");

    const authUrl =
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize` +
      `?client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scopes.join(" "))}` +
      `&state=${encodeURIComponent(jwtLocal ?? '')}`;

    window.location.href = authUrl;
  }

}
